module.exports = require('./helpers/bundle-url').getBundleURL('5HgvK') + "logo-dark.eefe0b7f.svg";